import { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

export default function OrderActionToast({ message,onDismiss,persistent=false,onRetry,retryLabel="주문 다시 불러오기" }: {message:string;onDismiss?:()=>void;persistent?:boolean;onRetry?:()=>void;retryLabel?:string}) {
  useEffect(() => {
    if (!message||persistent||!onDismiss) return;
    const timeout = window.setTimeout(onDismiss, 3000);
    return () => window.clearTimeout(timeout);
  }, [message,onDismiss,persistent]);
  if (!message) return null;
  return <Position><Notice key={message} role={persistent?"alert":"status"} aria-live={persistent?"assertive":"polite"} aria-atomic="true">
    <span>{message}</span>{onRetry&&<button className="retry" type="button" onClick={onRetry}>{retryLabel}</button>}{onDismiss&&<button type="button" aria-label="알림 닫기" onClick={onDismiss}>
      <svg viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
    </button>}
  </Notice></Position>;
}
const enter = keyframes`from { transform: translateY(var(--space-6)); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;
const Position = styled.div`
  position: fixed; z-index: var(--z-toast); bottom: calc(var(--space-6) + env(safe-area-inset-bottom));
  left: var(--space-4); right: var(--space-4); display: flex; justify-content: center; pointer-events: none;
`;
const Notice = styled.div`
  display: flex; align-items: center; gap: var(--space-4); max-width: 40rem; padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md); background: var(--color-bg-inverse); color: var(--color-text-on-inverse);
  box-shadow: var(--shadow-md); font-size: var(--text-body); line-height: var(--leading-body); pointer-events: auto;
  animation: ${enter} var(--duration-base) var(--ease-standard) both;
  span { min-width: 0; overflow-wrap: anywhere; }
  button { display: grid; place-items: center; flex-shrink: 0; width: var(--control-sm); height: var(--control-sm);
    padding: 0; border: 0; background: transparent; color: inherit; cursor: pointer; border-radius: var(--radius-sm); }
  button.retry{width:auto;padding:0 var(--space-2);white-space:nowrap;text-decoration:underline;text-underline-offset:var(--space-1);}
  button:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`;
